module.exports = __webpack_public_path__ + "img/prep.2ef16cdb.jpg";